import { useQueryClient } from '@tanstack/react-query';
import * as R from 'ramda';
import { useShallow } from 'zustand/react/shallow';
import { DataQueryKey } from '../../../../../../hooks/useDataQuery/dataQuery.types';
import useOrderBookStore from '../../../../../../stores/OrderBook/orderBook.store';
import { useApplicationContext } from '../../../../../context/ApplicationContext/ApplicationContext';
import { SavedStackItem } from '../../../../../orders/interfaces/use-order-item-stack.types';
import { invalidateAffectedOrderProductsGridQueries } from '../../../../../orders/utils/orderCalculate.utils';

export const useCatalogListGridAfterSave = () => {
  const { team } = useApplicationContext();
  const queryClient = useQueryClient();

  const { selectedOrderId, reloadOrderItemsQuantity } = useOrderBookStore(
    useShallow((state) => ({
      selectedOrderId: state.selectedOrder?.id,
      reloadOrderItemsQuantity: state.reloadOrderItemsQuantity,
    })),
  );

  const handleAfterSave = async (savedItems: SavedStackItem[]) => {
    if (!savedItems.length) {
      return;
    }

    await queryClient.refetchQueries({
      type: 'active',
      queryKey: [team?.id, DataQueryKey.ORDER_CALCULATE_SUMMARY],
    });

    const orderIds = R.uniq(savedItems.map(({ orderId }) => orderId));

    await Promise.all(
      orderIds.map(async (orderId) => {
        const affectedOrderProducts = await reloadOrderItemsQuantity(
          true,
          orderId,
          orderId === selectedOrderId,
        );

        if (!affectedOrderProducts?.length) {
          return;
        }

        invalidateAffectedOrderProductsGridQueries({
          orderId,
          queryClient,
          teamId: team?.id,
          isOfflineMode: false,
          affectedOrderProducts,
        });
      }),
    );
  };

  return { handleAfterSave };
};
